function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.048 7.768v-2.49c0-.946.571-1.145 1-1.145h2.571V0H7.095c-3.905 0-4.81 3.087-4.81 5.029v2.739H0V12h2.286v12h4.762V12h3.238l.38-4.232H7.049z",
  fill: "currentColor",
  fillRule: "nonzero"
});

function SvgIconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 24
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMSIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDExIDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICA8Zz4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik03LjA0OCA3Ljc2OHYtMi40OWMwLS45NDYuNTcxLTEuMTQ1IDEtMS4xNDVoMi41NzFWMEg3LjA5NWMtMy45MDUgMC00LjgxIDMuMDg3LTQuODEgNS4wMjl2Mi43MzlIMFYxMmgyLjI4NnYxMmg0Ljc2MlYxMmgzLjIzOGwuMzgtNC4yMzJINy4wNDl6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDA1IC04Mzc0KSB0cmFuc2xhdGUoNDA1IDgzNzQpIi8+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgIconFacebook as ReactComponent };